﻿<template>
    <q-dialog ref="dialogRef" class="auto-width" @hide="onDialogHide">
        <q-card>
            <q-card-section class="items-center">
                <q-markup-table flat dense>
                    <thead>
                        <tr>
                            <th class="text-center">{{ ts('severity') }}</th>
                            <th class="text-left">{{ ts('issue') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="issue in issueList" :key="issue.id">
                            <td class="text-center">
                                <q-icon name="error" color="negative" size="24px" v-if="issue.severity === 'crit'" />
                                <q-icon name="pending" color="secondary" size="24px" v-if="issue.severity === 'warn'" />
                                <q-icon
                                    name="check_circle"
                                    color="positive"
                                    size="24px"
                                    v-if="issue.severity === 'ok'"
                                />
                            </td>
                            <td>
                                {{ issue.what }}
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="ts('close')" color="primary" @click="onDialogCancel" />
                <q-btn flat :label="ts('uploadResults')" color="primary" @click="onSave" v-if="!isCrit" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import nvl from '@/utils/nvl'
import BoatClassesRepo from '@repo/BoatClassesRepo'
import MembersRepo from '@repo/MembersRepo'
import { useRepo } from 'pinia-orm'
import { useDialogPluginComponent } from 'quasar'
import { ts } from '@/plugins/i18nFormat'
import { rodnecislo } from 'rodnecislo'
import { computed, ref } from 'vue'

interface Props {
    color?: string
    issueList: object[]
}

const props = withDefaults(defineProps<Props>(), {
    icon: 'info',
    color: 'primary',
})

defineEmits([...useDialogPluginComponent.emits])

const issueList = ref(props.issueList)

const isCrit = computed(() => (issueList.value.some((i) => i.severity === 'crit')))

function onSave() {
    onDialogOK({ issueList: issueList.value })
}

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
</script>

<style scoped lang="sass">
.crew span
    font-size: 80%

.auto-width > div > div
    max-width: none !important
</style>
